import script from "./customGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./customGallery.vue?vue&type=script&setup=true&lang=js"

import "./customGallery.vue?vue&type=style&index=0&id=3d0910b6&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0910b6"]])

export default __exports__